// Import all broker assets
import tradexLogoFull from '../assets/brokers/tradex/logo_full.png';
import tradexLogoSmall from '../assets/brokers/tradex/logo_small.png';
import tradexFavicon from '../assets/brokers/tradex/favicon.png';

import stockkidaLogoFull from '../assets/brokers/stockkida/logo_full.png';
import stockkidaLogoSmall from '../assets/brokers/stockkida/logo_small.png';
import stockkidaFavicon from '../assets/brokers/stockkida/favicon.png';

import marketbhaiLogoFull from '../assets/brokers/marketbhai/logo_full.png';
import marketbhaiLogoSmall from '../assets/brokers/marketbhai/logo_small.png';
import marketbhaiFavicon from '../assets/brokers/marketbhai/favicon.ico';

import sevenOceanLogoFull from '../assets/brokers/7ocean/logo_full.png';
import sevenOceanLogoSmall from '../assets/brokers/7ocean/logo_small.png';
import sevenOceanFavicon from '../assets/brokers/7ocean/favicon.png';

import uatLogoFull from '../assets/brokers/uat/logo_full.png';
import uatLogoSmall from '../assets/brokers/uat/logo_small.png';
import uatFavicon from '../assets/brokers/uat/favicon.png';

import txltdLogoFull from '../assets/brokers/txltd/logo_full.png';
import txltdLogoSmall from '../assets/brokers/txltd/logo_small.png';
import txltdFavicon from '../assets/brokers/txltd/favicon.png';

import oneTradeLogoFull from '../assets/brokers/1trade/logo_full.png';
import oneTradeLogoSmall from '../assets/brokers/1trade/logo_small.png';
import oneTradeFavicon from '../assets/brokers/1trade/favicon.png';

import fiveTradeLogoFull from '../assets/brokers/5trade/logo_full.png';
import fiveTradeLogoSmall from '../assets/brokers/5trade/logo_small.svg';
import fiveTradeFavicon from '../assets/brokers/5trade/favicon.svg';




import trade246LogoFull from '../assets/brokers/trade246/logo_full.png';
import trade246LogoSmall from '../assets/brokers/trade246/logo_small.png';
import trade246Favicon from '../assets/brokers/trade246/favicon.png';

import bull500LogoFull from '../assets/brokers/bull500/logo_full.png';
import bull500LogoSmall from '../assets/brokers/bull500/logo_small.png';
import bull500Favicon from '../assets/brokers/bull500/favicon.png';

import niveshproLogoFull from '../assets/brokers/niveshpro/logo_full.png';
import niveshproLogoSmall from '../assets/brokers/niveshpro/logo_small.png';
import niveshproFavicon from '../assets/brokers/niveshpro/favicon.png';

import forvonexLogoFull from '../assets/brokers/forvonex/logo_full.png';
import forvonexLogoSmall from '../assets/brokers/forvonex/logo_small.png';
import forvonexFavicon from '../assets/brokers/forvonex/favicon.png';

import bullmintLogoFull from '../assets/brokers/bullmint/logo_full.png';
import bullmintLogoSmall from '../assets/brokers/bullmint/logo_small.png';
import bullmintFavicon from '../assets/brokers/bullmint/favicon.png';

import exnessLogoFull from '../assets/brokers/exness/logo_full.png';
import exnessLogoSmall from '../assets/brokers/exness/logo_small.png';
import exnessFavicon from '../assets/brokers/exness/favicon.png';

import mytrade24LogoFull from '../assets/brokers/mytrade24/logo_full.png';
import mytrade24LogoSmall from '../assets/brokers/mytrade24/logo_small.png';
import mytrade24Favicon from '../assets/brokers/mytrade24/favicon.png';

import tradenowLogoFull from '../assets/brokers/tradenow/logo_full.png';
import tradenowLogoSmall from '../assets/brokers/tradenow/logo_small.png';
import tradenowFavicon from '../assets/brokers/tradenow/favicon.png';




export const BROKER_CONFIGS = {
    'niveshpro': {
        title: 'NiveshPro',
        logoFull: niveshproLogoFull,
        logoSmall: niveshproLogoSmall,
        favicon: niveshproFavicon,
        showCountryPicker: true,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        support: {
            type: 'whatsapp',
            link: 'https://wa.link/trade'
        },

        signupLink: 'https://app.nivesh.pro/register',
        hideContact: false,
        socialLinks: {
            instagram: '',
            telegram: 'https://t.me/NiveshPro',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/niveshPro/NiveshPro-release-2.0.15.apk'
    },
    'bull500': {
        title: 'BULL500',
        showCountryPicker: false,
        logoFull: bull500LogoFull,
        logoSmall: bull500LogoSmall,
        favicon: bull500Favicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.bull500.com/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        }
    },
    'trade246': {
        title: 'TRADE246',
        showCountryPicker: false,
        logoFull: trade246LogoFull,
        logoSmall: trade246LogoSmall,
        favicon: trade246Favicon,
        // gtmId: 'GTM-W7D5NSMK',
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.trade246.com/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/trade246/Trade246-release-2.0.15.apk'
    },

    'tradex': {
        title: 'TRADEX',
        showCountryPicker: false,
        logoFull: tradexLogoFull,
        logoSmall: tradexLogoSmall,
        favicon: tradexFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.tradex1.live/register',
        support: {
            type: 'zoho',
            widgetCode: 'siqc7a6768be78ffed943b3fdea2c869ce6a3e8a2d21287ffee4d0db968e3dd71e8',
            loginWidgetCode: 'siq425abe1000af24ff39cd4bb3124a0b569d47c53c1fbbf68b571192a0fe6b5679',
            leadSource2: '6823819000006114001'
        },
        trustpilot: {
            url: 'https://www.trustpilot.com/review/tradex1.live',
            score: 4.0,
            ratingText: 'Great',
            reviewCount: 36,
        },
        socialLinks: {
            instagram: 'https://www.instagram.com/tradex1.live/',
            telegram: 'https://linktr.ee/Tradex55',
            facebook: 'https://www.facebook.com/profile.php?id=61560991236085',
            twitter: 'https://x.com/TradexLive1',
            youtube: 'https://www.youtube.com/@tradex_live'
        },
        feedback: {
            url: 'https://www.trustpilot.com/review/tradex1.live',
            threshold: 3
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/tradex/Tradex-release-2.0.15.apk'
    },
    'stockkida': {
        title: 'STOCKKIDA',
        showCountryPicker: false,
        logoFull: stockkidaLogoFull,
        logoSmall: stockkidaLogoSmall,
        favicon: stockkidaFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.stockkida.com/register',
        support: {
            type: 'whatsapp',
            link: 'https://walink.online/r/Stockkidacare'
        },
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/stockkida/Stockkida-release-2.0.15.apk'
    },
    'marketbhai': {
        title: 'MarketBhai',
        showCountryPicker: false,
        logoFull: marketbhaiLogoFull,
        logoSmall: marketbhaiLogoSmall,
        favicon: marketbhaiFavicon,
        // gtmId: 'GTM-KJ3G8CZ4',
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.marketbhai.com/register',
        support: {
            type: 'zoho',
            domain: 'salesiq.zohopublic.in',
            widgetCode: 'siqf6fe7cb7d8e100167d994f6e82cd3b5a0fffe2aa4292b01a0f91fb0292afef0e',
            loginWidgetCode: 'siqee7ed5c5a3edffdcbc9b6ff838382a04aa926323ae3c067cc966922765908fc3',
            leadSource2: '6823819000006114001',
            visitorInfo: {
                Lead_Source1: 'MAIN WEBSITE (HOT)',
                Lead_Source_2: 'ChatBot',
                CM_Lead_Source_1: 'MAIN WEBSITE (HOT)',
                CM_Lead_Source_2: '6823819000006114001',
            }
        },
        trustpilot: {
            url: 'https://www.trustpilot.com/review/marketbhai.com',
            score: 4.3,
            ratingText: 'Excellent',
            reviewCount: 101,
        },
        socialLinks: {
            instagram: 'https://www.instagram.com/marketbhai_official',
            telegram: 'https://t.me/marketbhai',
            facebook: '',
            twitter: '',
            youtube: 'https://m.youtube.com/@market-bhai'
        },
        feedback: {
            url: 'https://www.trustpilot.com/review/marketbhai.com',
            threshold: 3
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/marketbhai/Marketbhai-release-2.0.15.apk'
    },
    '7ocean': {
        title: '7Ocean',
        showCountryPicker: false,
        logoFull: sevenOceanLogoFull,
        logoSmall: sevenOceanLogoSmall,
        favicon: sevenOceanFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.7ocean.site/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/7ocean/7Ocean-release-2.0.15.apk'
    },
    '1trade': {
        title: '1Trade',
        showCountryPicker: false,
        logoFull: oneTradeLogoFull,
        logoSmall: oneTradeLogoSmall,
        favicon: oneTradeFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.1trade.info/register',
        hideContact: false,
        support: {
            type: 'zoho',
            widgetCode: 'siqa30a06764cf833fc226edf72cb5440b3b0ccae3acc576a6ab399a70131f66d1e',
            loginWidgetCode: 'siqa30a06764cf833fc226edf72cb5440b3acce82571b7d7e1a0e7bf9ef691d83d0',
            leadSource2: '6823819000006114001'
        },
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/1trade/1trade-release-2.0.15.apk'
    },
    '5trade': {
        title: '5Trade',
        showCountryPicker: false,
        logoFull: fiveTradeLogoFull,
        logoSmall: fiveTradeLogoSmall,
        favicon: fiveTradeFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        support: {
            type: 'zoho',
            widgetCode: 'siq265d604a6d8525c0d2d9f7af4a26c672f00acdf640007aa43eb76cc8787fb1b5',
        },
        signupLink: 'https://app.5trade.live/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/5trade/5Trade-release-2.0.15.apk'
    },
    'uat': {
        title: 'Trading Pro',
        showCountryPicker: true,
        logoFull: uatLogoFull,
        logoSmall: uatLogoSmall,
        favicon: uatFavicon,
        // gtmId: 'GTM-KJ3G8CZ4',
        // recaptchaSiteKey: '6Lf2y4YsAAAAAE86p2-WGFxcYFJuSuNfyhdcxVWa',
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app-uat.tradex1.live/register',
        support: {
            type: 'zoho',
            widgetCode: 'siqc7a6768be78ffed943b3fdea2c869ce6a3e8a2d21287ffee4d0db968e3dd71e8',
            loginWidgetCode: 'siq425abe1000af24ff39cd4bb3124a0b569d47c53c1fbbf68b571192a0fe6b5679',
            leadSource2: '6823819000006114001'
        },
        socialLinks: {
            instagram: 'https://www.instagram.com/',
            telegram: 'https://telegram.org/',
            facebook: 'https://www.facebook.com/',
            twitter: 'https://x.com/',
            youtube: 'https://www.youtube.com/'
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/tradex/Tradex-release-2.0.15.apk'
    },
    'txltd': {
        title: 'TFXLTD',
        showCountryPicker: false,
        logoFull: txltdLogoFull,
        logoSmall: txltdLogoSmall,
        favicon: txltdFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.txltd.co/register',
        support: {
            type: 'zoho',
            widgetCode: 'siq29f64b49cf3406f69ae940887a2f015425f09b3209731cd5574760d88310d485',
            leadSource2: ''
        },
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        }
    },
    'forvonex': {
        title: 'Forvonex',
        showCountryPicker: false,
        logoFull: forvonexLogoFull,
        logoSmall: forvonexLogoSmall,
        favicon: forvonexFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.forvonex.com/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/forvonex/Forvonex-release-2.0.15.apk'
    },
    'bullmint': {
        title: 'BULLMINT',
        showCountryPicker: true,
        logoFull: bullmintLogoFull,
        logoSmall: bullmintLogoSmall,
        favicon: bullmintFavicon,
        logoDimensions: {
            login: { width: 220, height: 60 },
            appBar: { width: 180, height: 60 }
        },
        signupLink: 'https://app.bullmint.app/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/bullmint/BullMint-release-2.0.15.apk'
    },
    'mytrade24': {
        title: 'MyTrade24',
        showCountryPicker: true,
        logoFull: mytrade24LogoFull,
        logoSmall: mytrade24LogoSmall,
        favicon: mytrade24Favicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.mytrade.in/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        },
        apkLink: 'https://prod-android-application.s3.ap-south-1.amazonaws.com/mytrade24/Mytrade24-release-2.0.15.apk'
    },
    'exness': {
        title: 'EXNESS',
        showCountryPicker: true,
        logoFull: exnessLogoFull,
        logoSmall: exnessLogoSmall,
        favicon: exnessFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.exnesstock.com/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        }
    },
    'tradenow': {
        title: 'TRADENOW',
        showCountryPicker: true,
        logoFull: tradenowLogoFull,
        logoSmall: tradenowLogoSmall,
        favicon: tradenowFavicon,
        logoDimensions: {
            login: { width: 160, height: 'auto' },
            appBar: { width: 140, height: 45 }
        },
        signupLink: 'https://app.tradenow.biz/register',
        hideContact: true,
        socialLinks: {
            instagram: '',
            telegram: '',
            facebook: '',
            twitter: '',
            youtube: ''
        }
    }
};

const currentBrokerId = process.env.REACT_APP_BROKER_ID || 'uat';
console.log("process.env.REACT_APP_BROKER_ID", process.env.REACT_APP_BROKER_ID, currentBrokerId);
export const brokerConfig = BROKER_CONFIGS[currentBrokerId] || BROKER_CONFIGS['marketbhai'];

export default brokerConfig;
